import axios, { AxiosInstance } from "axios";
import {
  API_KEY_CAD,
  API_KEY_EURO,
  API_SECRET_CAD,
  API_SECRET_EURO,
  API_URL,
} from "../../utils/globals";
import { createSignature } from "../../utils/hmac";
import {
  AcceptFiatInstanceRequest,
  AcceptFiatInstanceResponse,
  CreatePayinRequest,
  CreatePayinResponse,
  GetFiatInstanceDetailsResponse,
} from "../models/PrimeFiat";

class PrimeFiatApiService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: API_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  public async createPayin(
    body: CreatePayinRequest,
    currency: string,
  ): Promise<CreatePayinResponse> {
    const signature = createSignature(
      currency === "EUR" ? API_SECRET_EURO : API_SECRET_CAD,
      body,
    );
    const response = await this.api.post<CreatePayinResponse>(
      currency === "EUR"
        ? "/v2/prime-fiat/instance/payin"
        : "/v2/prime-fiat/cad/instance/payin",
      body,
      {
        headers: {
          "X-TLP-APIKEY": currency === "EUR" ? API_KEY_EURO : API_KEY_CAD,
          "X-TLP-SIGNATURE": signature,
        },
      },
    );
    return response.data;
  }

  public async getInstanceDetails(
    instanceId: string,
    region: string,
  ): Promise<GetFiatInstanceDetailsResponse> {
    const response = await this.api.get<GetFiatInstanceDetailsResponse>(
      region === "cad"
        ? "/v2/prime-fiat/cad/instance/details/internal"
        : "/v2/prime-fiat/instance/details/internal",
      { params: { instanceId } },
    );
    return response.data;
  }

  public async acceptPayin(
    body: AcceptFiatInstanceRequest,
    region: string,
  ): Promise<AcceptFiatInstanceResponse> {
    const response = await this.api.post<AcceptFiatInstanceResponse>(
      region === "cad"
        ? "/v2/prime-fiat/cad/instance/payin/accept"
        : "/v2/prime-fiat/instance/payin/accept",
      body,
    );
    return response.data;
  }
}

export const primeFiatApiServices = new PrimeFiatApiService();
